(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll('.video_banner');
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // SVG icons for mute and unmute
    const muteIcon = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24px" height="24px">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.06c1.48-.73 2.5-2.25 2.5-4.03zM12 3.5v2.06c3.01.91 5 3.69 5 6.44s-1.99 5.53-5 6.44v2.06c4.01-1.02 7-4.69 7-8.5s-2.99-7.48-7-8.5zM4 9v6h4l5 5V4L8 9H4z"/>
        </svg>
    `;
    const unmuteIcon = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24px" height="24px">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.06c1.48-.73 2.5-2.25 2.5-4.03zM12 3.5v2.06c3.01.91 5 3.69 5 6.44s-1.99 5.53-5 6.44v2.06c4.01-1.02 7-4.69 7-8.5s-2.99-7.48-7-8.5zM4 9v6h4l5 5V4L8 9H4zM21 4.27l-1.41-1.41L0 21.86 1.41 23.27 5 19.68V22h6v-5.73l3.29-3.29c.12.1.26.19.41.27v-1.78l1.43-1.43c-.25-.55-.58-1.05-.98-1.49L21 4.27z"/>
        </svg>
    `;

    // Create an intersection observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
                video.play();
                if (!isMobile) {
                    video.muted = false;  // Unmute only on non-mobile devices
                }
            } else {
                video.pause();
                video.muted = true;
            }
        });
    }, { threshold: 0.5 });

    // Mute/unmute button functionality for mobile
    videos.forEach(video => {
        observer.observe(video);

        // For mobile: ensure videos start muted and autoplay
        if (isMobile) {
            video.muted = true;
            video.play();

            // Create a mute/unmute button for mobile
            const muteButton = document.createElement('button');
            muteButton.classList.add('mute-toggle');
            muteButton.innerHTML = video.muted ? unmuteIcon : muteIcon;  // Set initial icon

            // Toggle mute/unmute when the button is clicked
            muteButton.addEventListener('click', function () {
                if (video.muted) {
                    video.muted = false;
                    muteButton.innerHTML = muteIcon;  // Change to unmute icon
                } else {
                    video.muted = true;
                    muteButton.innerHTML = unmuteIcon;  // Change to mute icon
                }
            });

            // Add the button to the DOM (positioned inside video wrapper)
            video.parentElement.appendChild(muteButton);
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  
// document.addEventListener("DOMContentLoaded", function () {
//     const videos = document.querySelectorAll('.slideshow_video'); // Select all videos with class "myVideo"

//     // Create an intersection observer
//     const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//             const video = entry.target; // Get the video element
//             if (entry.isIntersecting) {
//                 // Video is in view, play and unmute it
//                 video.play();
//                 video.muted = false;
//             } else {
//                 // Video is out of view, pause and mute it
//                 video.pause();
//                 video.muted = true;
//             }
//         });
//     }, { threshold: 0.5 }); // threshold determines how much of the video should be visible

//     // Start observing each video
//     videos.forEach(video => {
//         observer.observe(video);
//     });
// });



  } catch(e) { console.error(e); }
})();
})();
